import React from 'react';
import styled from 'styled-components';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var MatchTextWrapper = styled.span.withConfig({
  displayName: "MatchTextWidth__MatchTextWrapper",
  componentId: "sc-308qdi-0"
})(["display:inline-grid;align-items:center;& > span{grid-area:1 / 1;}& > [aria-hidden='true']{visibility:hidden;}"]);
/**
 * Toggle between main and alternative content without changing how much space is used.
 * The component will always take up as much space as the longest content.
 *
 * Useful for toggling button labels without changing the size of the button.
 */

function MatchTextWidth(_ref) {
  var children = _ref.children,
    alternativeText = _ref.alternativeText,
    showAlternativeText = _ref.showAlternativeText;
  return /*#__PURE__*/_jsxs(MatchTextWrapper, {
    children: [/*#__PURE__*/_jsx("span", {
      "aria-hidden": showAlternativeText,
      children: children
    }), /*#__PURE__*/_jsx("span", {
      "aria-hidden": !showAlternativeText,
      children: alternativeText
    })]
  });
}
export default MatchTextWidth;